import { getActiveTransaction, spanToJSON } from '@sentry/core';
import { logger } from '@sentry/utils';
import { DEBUG_BUILD } from '../common/debug-build.js';
import { WINDOW } from './types.js';
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */

function registerBackgroundTabDetection() {
  if (WINDOW && WINDOW.document) {
    WINDOW.document.addEventListener('visibilitychange', function () {
      // eslint-disable-next-line deprecation/deprecation
      var activeTransaction = getActiveTransaction();

      if (WINDOW.document.hidden && activeTransaction) {
        var statusType = 'cancelled';

        var _spanToJSON = spanToJSON(activeTransaction),
            op = _spanToJSON.op,
            status = _spanToJSON.status;

        DEBUG_BUILD && logger.log("[Tracing] Transaction: ".concat(statusType, " -> since tab moved to the background, op: ").concat(op)); // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.

        if (!status) {
          activeTransaction.setStatus(statusType);
        } // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation


        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.end();
      }
    });
  } else {
    DEBUG_BUILD && logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}

export { registerBackgroundTabDetection };